<template>
  <div
    class="gw_range_select gwrss"
    style="--width: var(--clrpickr-menu-width)"
  >
    <div
      v-for="rr in [
        { id: 'from', value: from },
        { id: 'to', value: to },
      ]"
      :key="rr.key"
      class="f-column"
    >
      <slot :name="`title_${rr.id}`"></slot>
      <GwBtns
        class="gwbtns_vertical_white"
        :options="options"
        :value="rr.value"
        @click="
          (_e, item) => {
            handleUpdate({ key: rr.id, item })
          }
        "
      >
        <template #default="{ item }">
          {{ item }}
        </template>
      </GwBtns>
    </div>
  </div>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'

export default {
  name: 'GwRangeSelect',
  components: {
    GwBtns,
  },
  props: {
    from: [String, Number],
    to: [String, Number],
    options: Array,
  },
  emits: ['update'],
  data() {
    return {}
  },
  methods: {
    handleUpdate({ key, item }) {
      const res = {
        from: this.from || this.options[0],
        to: this.to || this.options[this.options.length - 1],
        [key]: item,
      }

      if (res.from && res.to && res.from > res.to) {
        res[key === 'to' ? 'from' : 'to'] =
          this.options[this.options.findIndex(o => o === res[key])]
      }

      this.$emit('update', res)
    },
  },
}
</script>
<style lang="scss" scoped>
.gwrss {
  display: flex;
  gap: 1rem;
}
</style>
